import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import FillDownArrowIcon from "../../icons-svg/FillDownArrowIcon";
import UserIcon from "../../icons-svg/UserIcon";
import { logoutAsync } from "../../features/auth/authSlice";

const UserAccount = () => {
  const ref = useRef();
  const { t } = useTranslation();
  const [toggle, setToggle] = useState(false);
  const user = useSelector((state) => state.auth.userInfo);
  const dispatch = useDispatch();

  useEffect(() => {
    const clickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setToggle(false);
      }
    };

    document.addEventListener("click", clickOutside, true);

    return () => {
      document.removeEventListener("click", clickOutside, true);
    };
  }, []);

  const toggleOnClick = (e) => {
    e.preventDefault();
    setToggle((oldToggle) => !oldToggle);
  };

  const onLogout = (e) => {
    dispatch(logoutAsync());
  };

  return (
    <div ref={ref} className="cursor-pointer">
      <button
        onClick={toggleOnClick}
        className="py-1 px-1 flex text-sm rounded-full focus:outline-none dark:text-gray-100"
        id="user-menu-button"
      >
        <div className="relative cursor-pointer">
          <UserIcon className="cursor-pointer h-4 w-4 text-[#9CCAFE]" />
        </div>
        <span className="hidden md:block ltr:ml-1 rtl:mr-1 self-center cursor-pointer" style={{color:"#9CCAFE"}}>
          {user?.login}
        </span>
        <span className="hidden md:block pt-1.5 pl-2 cursor-pointer">
          <FillDownArrowIcon className="h-3 w-3" style={{color:"9CCAFE"}}/>
        </span>
      </button>
      {toggle && (
        <ul
          className="font-roboto text-xs12 transition-all duration-200 ease-out origin-top-right absolute ltr:right-0 rtl:left-0 rounded top-full z-[51] py-0.5 ltr:text-left rtl:text-right bg-white shadow-md"
  style={{ minWidth: "12rem" }}
        >
          <li className="relative">
            <hr className="border-t border-gray-200 my-0" />
          </li>
          <li
            className="relative cursor-pointer"
            onClick={(e) => setToggle(false)}
          >
          </li>
          <li className="relative">
            <hr className="border-t border-gray-200 my-0" />
          </li>
          <li className="relative cursor-pointer">
            <button
              type="button cursor-pointer"
              onClick={onLogout}
              className="flex items-center w-full py-2 px-6 clear-both whitespace-nowrap hover:text-indigo-500"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                className="cursor-pointer inline ltr:mr-2 rtl:ml-2 w-4 h-4"
                viewBox="0 0 16 16"
              >
                <path
                  fillRule="evenodd"
                  d="M6 3.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 0-1 0v2A1.5 1.5 0 0 0 6.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-8A1.5 1.5 0 0 0 5 3.5v2a.5.5 0 0 0 1 0v-2z"
                ></path>
                <path
                  fillRule="evenodd"
                  d="M11.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H1.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z"
                ></path>
              </svg>
              &nbsp;{t(`Sign out`)}
            </button>
          </li>
        </ul>
      )}
    </div>
  );
};

export default UserAccount;
